import React, { useContext } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import TextInput from "components/Input/TextInput.js";
import { compte } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { updateAccountDso } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function EditUserDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    energy,
    parameters,
    closeModal,
    refetch,
    idSelected,
    prevDsoList,
    clef,
    name,
    handleClefChange,
    handleNameChange,
  } = props;

  const handleSubmit = async (event) => {
    const editedDetails = {
      clef,
      name,
    };

    const editedDso= {
      'uuid': idSelected,
      details : editedDetails,
    };


    axios
      .put(
        updateAccountDso(idSelected,chartIdGroup,energy),
        editedDso,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
      })
      .catch(() => { });
  };


  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>

            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              noWrap
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditUserDialog;
